import React from 'react';

const StepperMinusIcon = () => {
    return (
        <svg width="12" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 7H12" stroke="#004080" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};

export default StepperMinusIcon;
